export const cookieBannerText = {
  title: 'Cookies improve your experience',
  description: `By clicking "Accept all cookies" you agree to our use of cookies as described in our Privacy Policy and Cookie Settings below. To reject all non-essential cookies, click "Decline all cookies." To change your cookie settings, click "Cookie settings." See our Privacy Policy for more information.`,
  privacyPolicy: {
    label: 'Privacy Policy',
    url: 'https://www.notion.so/healingpapercareer/Privacy-Policy-From-February-27th-2025-907c569149544fa1a1dc2ba48e6e5230',
  },
  buttons: {
    acceptAll: 'Accept all',
    rejectAll: 'Reject all',
    settings: 'Cookie Settings',
  },
}
